import {
  evaluateAXRuntimeDecision,
} from './AXRuntimeDecisionEngine';

export type AXRuntimeAction =
  | 'continue'
  | 'redirect'
  | 'deny';

export interface AXRuntimeActionResult {
  readonly action: AXRuntimeAction;
  readonly governor: string;
  readonly reason: string;
  readonly generatedAt: string;
}

export function determineAXRuntimeAction():
AXRuntimeActionResult {

  const decision =
    evaluateAXRuntimeDecision();

  let action: AXRuntimeAction = 'continue';

  if (decision.decision === 'block') {
    action = 'deny';
  } else if (decision.decision === 'redirect') {
    action = 'redirect';
  }

  return Object.freeze({
    action,
    governor: decision.governor,
    reason: decision.reason,
    generatedAt: decision.evaluatedAt,
  });
}
